// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 14) return "static/js/29ba874c7df96b1b3a4d.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"f19ff25df6a3aea6c4c3","212":"c4623f2d1ce8b7652aa9","213":"96865e16077cd1eca2d4"}[chunkId] + ".chunk.js";
};